(() => {
  const groups = {
    outerwear: ['ytterklader-sortiment', 'ytter-mossor', 'ytter-vantar', 'ytter-halsdukar', 'ytter-understall'],
    jeans: ['fit-slim', 'fit-regular', 'fit-loose', 'fit-wide', 'fit-bootcut', 'denim-joggers', 'denim-jeggings'],
    socks: ['halkstrumpor'],
    shoes: ['sko-sneakers', 'sko-sandaler', 'sko-stovlar-kangor', 'sko-tofflor-tossor'],
    accessories: ['acc-vaskor', 'acc-har', 'acc-smycken', 'acc-solglasogon', 'acc-skarp-balten'],
    pajamas: ['helpyjamas', '2-delad-pyjamas'],
    underwear: ['bh-top', 'trosor', 'kalsonger', 'underkladeslinne'],
    sleeves: ['kortarmad', 'langarmad', 'armlos', 'trekvartsarm'],
    sweats: ['med-luva', 'utan-luva', 'med-dragkedja'],
    skirts: ['kort-kjol', 'lang-kjol', 'skort'],
    sleepwear: ['pyjamas', 'nattlinne', 'morgonrock'],
    overalls: ['overall-vinter', 'overall-softshell-vind', 'overall-fleece', 'overall-ull', 'overall-ovriga'],
    rainwear: ['regnset', 'regnjacka-separat', 'regnbyxa-separat'],
    jackets: ["vinterjacka", "softshelljacka", "regnjacka", "fleece-teddy", "jeansjacka", "ovriga-jackor"],
    swimwear: ['bikini', 'baddrakt', 'badshorts', 'badbyxor-tajt', 'badblojbyxor', 'uv-klader'],
    characters: ['spider-man', 'minecraft', 'pippi', 'stitch', 'pokemon', 'sonic', 'bamse', 'disney', 'paw-patrol', 'frozen', 'bluey', 'kuromi', 'licence']
  };
  const tagNames = { baddrakt: 'baddräkt', badblojbyxor: 'badblöjbyxor', 'uv-klader': 'uv-kläder', '2-delad-pyjamas': '2-delad pyjamas', underkladeslinne: 'underklädeslinne', nattlinne: 'NATTLINNE', kortarmad: 'kortärmad', langarmad: 'långärmad', armlos: 'ärmlös', trekvartsarm: 'trekvartsärm', pokemon: 'POKEMON', 'spider-man': 'Spider-Man', pippi: 'Pippi', kuromi: 'Kuromi', bamse: 'Bamse' };
  const ageTags = { babyklader: 'baby', 'barnklader-1-5-ar': 'mini', 'barnklader-6-12-ar': 'kids', ungdomsklader: 'ungdom' };
  const handle = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9-]+/g, '-').replace(/^-|-$/g, '');
  const known = Object.values(groups).flat();
  const availabilityCache = new Map();
  function availableChoices(destination) {
    const url = new URL(destination, location.origin);
    url.hash = '';
    url.searchParams.delete('page');
    url.searchParams.delete('sections');
    url.searchParams.set('section_id', 'zinko-filter-availability');
    url.searchParams.sort();
    const key = url.toString();
    const cached = availabilityCache.get(key);
    if (cached && Date.now() - cached.time < 60000) return cached.promise;
    const promise = (async () => {
      const tags = new Set();
      const types = new Set();
      let next = url;
      const visited = new Set();
      while (next && !visited.has(next.toString())) {
        visited.add(next.toString());
        const response = await fetch(next, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Filter availability unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = JSON.parse(document.querySelector('[data-zinko-availability]').textContent);
        data.tags.split('|').filter(Boolean).forEach(tag => tags.add(tag));
        data.types.split('|').filter(Boolean).forEach(type => types.add(type));
        next = data.next ? new URL(data.next, url) : null;
        if (next) next.searchParams.set('section_id', 'zinko-filter-availability');
      }
      return { tags, types };
    })();
    availabilityCache.set(key, { promise, time: Date.now() });
    promise.catch(() => availabilityCache.delete(key));
    if (availabilityCache.size > 40) availabilityCache.delete(availabilityCache.keys().next().value);
    return promise;
  }
  function readTags(url = new URL(location.href)) {
    if (url.pathname.includes('/collections/')) return (url.pathname.split('/')[3] || '').split('+').filter(Boolean).map(decodeURIComponent);
    return [...(url.searchParams.get('q') || '').matchAll(/(?<!NOT )tag:"([^"]+)"/g)].map(match => handle(match[1])).filter(value => known.includes(value) || Object.values(ageTags).includes(value));
  }
  function searchText(url) {
    const saved = url.searchParams.get('zinko_q');
    return saved === null ? (url.searchParams.get('q') || '') : saved;
  }
  function tagUrl({ tags, base, params, scope, text, forceSearch = false }) {
    const url = new URL(base || location.href, location.origin);
    if (params) url.search = params.toString();
    url.searchParams.delete('page');
    url.searchParams.delete('zinko_types');
    url.searchParams.delete('zinko_outer');
    const characters = tags.filter(tag => groups.characters.includes(tag) && tag !== 'licence');
    if (url.pathname.includes('/search') || forceSearch || characters.length > 1 || tags.some(tag => groups.swimwear.includes(tag))) {
      const original = new URL(location.href);
      const plainText = text === undefined ? (original.pathname.includes('/search') ? searchText(original) : '') : text;
      const clauses = plainText ? [`(${plainText})`] : [];
      const age = ageTags[scope];
      if (age) clauses.push(`tag:"${age}"`);
      const regular = tags.filter(tag => !characters.includes(tag) && !Object.values(ageTags).includes(tag));
      regular.forEach(tag => clauses.push(`tag:"${tagNames[tag] || tag}"`));
      if (tags.includes('baddrakt')) clauses.push('NOT tag:"bikini"', 'NOT tag:"uv-kläder"');
      if (tags.includes('uv-klader')) clauses.push('NOT tag:"uv-filt"', 'NOT tag:"uvfilt"');
      if (characters.length) clauses.push(`(${characters.map(tag => `tag:"${tagNames[tag] || tag}"`).join(' OR ')})`);
      url.pathname = '/search';
      url.searchParams.set('q', clauses.join(' AND ') || '*');
      url.searchParams.set('zinko_q', plainText);
      url.searchParams.set('type', 'product');
      if (scope) url.searchParams.set('zinko_scope', scope);
      if (!['relevance', 'price-ascending', 'price-descending'].includes(url.searchParams.get('sort_by'))) url.searchParams.delete('sort_by');
    } else {
      url.pathname = url.pathname.split('/').slice(0, 3).join('/') + (tags.length ? `/${[...new Set(tags)].join('+')}` : '');
      url.searchParams.delete('q');
      url.searchParams.delete('zinko_q');
      url.searchParams.delete('zinko_scope');
      url.searchParams.delete('type');
      url.searchParams.delete('options[prefix]');
    }
    return url;
  }
  function outerwearUrl({ base, params, scope, value, tags: currentTags }) {
    const source = new URL(base || location.href, location.origin);
    if (params) source.search = params.toString();
    source.searchParams.delete('filter.p.product_type');
    const tags = (currentTags || readTags(source)).filter(tag => !Object.entries(groups).some(([key, values]) => key !== 'characters' && values.includes(tag)));
    tags.push(value);
    return tagUrl({ tags, base: source, scope, forceSearch: new URL(location.href).pathname.includes('/search') });
  }
  function categoryUnionUrl({ base, params, scope, types, choices, tags, text }) {
    if (!types.length && choices.length === 1) return outerwearUrl({ base, params, scope, value: choices[0], tags });
    const url = tagUrl({ base, params, scope, tags, text, forceSearch: true });
    url.searchParams.delete('filter.p.product_type');
    const quote = value => JSON.stringify(value);
    const alternatives = [...types.map(type => `product_type:${quote(type)}`), ...choices.map(tag => `tag:${quote(tag)}`)];
    const query = url.searchParams.get('q');
    url.searchParams.set('q', `${query === '*' ? '' : query + ' AND '}(${alternatives.join(' OR ')})`);
    url.searchParams.set('zinko_types', JSON.stringify(types));
    url.searchParams.set('zinko_outer', choices.join(','));
    return url;
  }
  function modesFor(types) {
    const modes = new Set();
    types.forEach(type => {
      const label = type.toLowerCase();
      if (/^(skor|sneakers|sandaler|stövlar|kängor|tofflor)$|babysko|toss/.test(label)) modes.add('shoes');
      if (/accessoar|smyck|väska|väskor|ryggsäck|necessär|skärp|bälte|hår|halsband|armband|solglas/.test(label)) modes.add('accessories');
      if (/regnställ|regnkläder|regnjack|regnbyx/.test(label)) modes.add('rainwear');
      else if (/jack/.test(label)) modes.add('jackets');
      if (/overall/.test(label)) modes.add('overalls');
      if (/bad|uv|bikini/.test(label)) { modes.add('swimwear'); return; }
      if (!/underkläder/.test(label) && /body|t-shirt|topp|skjort|blus|linnen|klänning/.test(label)) modes.add('sleeves');
      if (/hood|sweatshirt/.test(label)) modes.add('sweats');
      if (/jeans/.test(label)) modes.add('jeans');
      if (/kjol/.test(label)) modes.add('skirts');
      if (/underkläder/.test(label)) modes.add('underwear');
      if (/pyjamas|nattkläder|nattlinne|morgonrock/.test(label)) modes.add('sleepwear');
    });
    return modes;
  }
  if (!customElements.get('zinko-filter-context')) {
    customElements.define('zinko-filter-context', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-outerwear-fallback') && !readTags().some(tag => groups.outerwear.includes(tag))) { this.hidden = true; return; }
        this.updateLinks();
        this.addEventListener('pointerdown', () => { this.cancelSwipeHint(); this.updateLinks(); });
        this.addEventListener('focusin', () => { this.cancelSwipeHint(); this.updateLinks(); });
        this.addEventListener('click', event => {
          const arrow = event.target.closest('[data-category-scroll]');
          if (!arrow) return;
          const strip = this.querySelector('nav');
          strip?.scrollBy({ left: Number(arrow.dataset.categoryScroll) * strip.clientWidth * .75, behavior: 'smooth' });
        });
        this.addEventListener('scroll', () => this.updateArrows(), true);
        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this);

      }
      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.cancelSwipeHint();
        this.availabilityRevision = (this.availabilityRevision || 0) + 1;
      }
      cancelSwipeHint() {
        this.hintShown = true;
        cancelAnimationFrame(this.hintFrame);
        if (this.hintStrip) this.hintStrip.style.scrollBehavior = this.hintBehavior;
        this.hintObserver?.disconnect();
      }
      showSwipeHint() {
        if (this.hintShown || this.hintObserver) return;
        const strip = this.querySelector('nav');
        if (!strip || strip.scrollWidth - strip.clientWidth <= 2) return;
        const selected = strip.querySelector('[aria-current="true"]');
        if (!this.positioned) {
          if (selected) strip.scrollLeft = Math.max(0, selected.getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft - 16);
          this.positioned = true;
        }
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) { this.hintShown = true; return; }
        this.hintObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.hintObserver.disconnect();
          this.hintShown = true;
          const start = strip.scrollLeft;
          const maximum = strip.scrollWidth - strip.clientWidth;
          const distance = Math.min(28, maximum - start) > 4 ? Math.min(28, maximum - start) : -Math.min(28, start);
          const behavior = strip.style.scrollBehavior;
          this.hintStrip = strip;
          this.hintBehavior = behavior;
          strip.style.scrollBehavior = 'auto';
          let began;
          const step = now => {
            began ??= now;
            const progress = Math.min(1, (now - began) / 900);
            strip.scrollLeft = start + Math.sin(Math.PI * progress) ** 2 * distance;
            if (progress < 1 && this.isConnected) this.hintFrame = requestAnimationFrame(step);
            else { strip.style.scrollBehavior = behavior; this.updateArrows(); }
          };
          this.hintFrame = requestAnimationFrame(step);
        }, { threshold: .6 });
        this.hintObserver.observe(this);
      }
      updateArrows() {
        const strip = this.querySelector('nav');
        if (!strip) return;
        const maximum = strip.scrollWidth - strip.clientWidth;
        this.querySelectorAll('[data-category-scroll]').forEach(button => {
          button.hidden = maximum <= 2;
          button.disabled = Number(button.dataset.categoryScroll) < 0 ? strip.scrollLeft <= 2 : strip.scrollLeft >= maximum - 2;
        });
      }
      updateAvailability() {
        const revision = this.availabilityRevision = (this.availabilityRevision || 0) + 1;
        const typeLinks = [...this.querySelectorAll('[data-type-link]')];
        const featureLinks = [...this.querySelectorAll('[data-feature-link]')].filter(link => link.dataset.featureValue);
        const allTypes = this.querySelector('[data-type-all]');
        const outerLinks = [...this.querySelectorAll('[data-outerwear-link]')];
        const featureGroups = [...new Set(featureLinks.map(link => link.dataset.featureLink))];
        const jobs = featureGroups.map(group => {
          const links = featureLinks.filter(link => link.dataset.featureLink === group);
          const all = this.querySelector(`[data-feature-link="${group}"][data-feature-value=""]`);
          const source = new URL((allTypes || all || links[0]).href);
          const scope = source.searchParams.get('zinko_scope') || document.querySelector('zinko-store-categories')?.dataset.scope || 'all';
          const base = tagUrl({ tags: readTags(source).filter(tag => !groups[group].includes(tag)), base: source, scope });
          return { links, base, group };
        });
        if (typeLinks.length && allTypes && !jobs.length) jobs.push({ links: [], base: allTypes.href });
        if (!this.availabilityInitialized) {
          [...typeLinks, ...featureLinks, ...outerLinks].forEach(link => { link.hidden = link.getAttribute('aria-current') !== 'true'; });
          this.availabilityInitialized = true;
        }
        jobs.forEach(({ links, base, group }) => {
          availableChoices(base).then(({ tags, types }) => {
            if (revision !== this.availabilityRevision || !this.isConnected) return;
            links.forEach(link => { link.hidden = !tags.has(link.dataset.featureValue) && link.getAttribute('aria-current') !== 'true'; });
            typeLinks.forEach(link => {
              const values = JSON.parse(link.dataset.typeValues || JSON.stringify([link.dataset.typeLink]));
              link.hidden = !values.some(value => types.has(value.toLowerCase())) && link.getAttribute('aria-current') !== 'true';
            });
            outerLinks.forEach(link => { link.hidden = !tags.has(link.dataset.outerwearLink) && link.getAttribute('aria-current') !== 'true'; });
            if (group === 'pajamas') {
              const selected = links.some(link => link.getAttribute('aria-current') === 'true');
              this.hidden = groups.pajamas.filter(tag => tags.has(tag)).length < 2 && !selected;
            }
            this.updateArrows();
            this.showSwipeHint();
          }).catch(() => {
            if (revision !== this.availabilityRevision || !this.isConnected) return;
            [...typeLinks, ...links, ...outerLinks].forEach(link => { link.hidden = false; });
            this.updateArrows();
            this.showSwipeHint();
          });
        });
        if (!jobs.length) this.showSwipeHint();
      }
      groupActiveCategories() {
        const drawer = document.querySelector('zinko-store-categories');
        if (!drawer) return;
        const current = new URL(location.href);
        const selected = current.searchParams.getAll('filter.p.product_type').flatMap(value => value.split(','));
        drawer.querySelectorAll('[data-category-group]').forEach(group => {
          const values = [...group.querySelectorAll('[data-product-type]:not(:disabled)')].map(input => input.value);
          if (!values.length || !values.every(value => selected.includes(value))) return;
          const label = group.querySelector('[data-category-toggle]').textContent.trim();
          document.querySelectorAll('.active-facets').forEach(row => {
            const chips = [...row.querySelectorAll('facet-remove')].filter(chip => {
              const link = chip.querySelector('a');
              if (!link || !link.href.includes('filter.p.product_type')) return false;
              const remaining = new URL(link.href).searchParams.getAll('filter.p.product_type').flatMap(value => value.split(','));
              return values.some(value => selected.includes(value) && !remaining.includes(value));
            });
            if (!chips.length) return;
            const chip = chips.shift();
            const link = chip.querySelector('a');
            const url = new URL(link.href);
            url.searchParams.delete('filter.p.product_type');
            selected.filter(value => !values.includes(value)).forEach(value => url.searchParams.append('filter.p.product_type', value));
            link.href = url.toString();
            const inner = link.querySelector('.active-facets__button-inner');
            if (inner) {
              [...inner.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => node.remove());
              inner.prepend(document.createTextNode(label + ' '));
            }
            chips.forEach(other => other.remove());
          });
        });
      }
      updateLinks() {
        const current = new URL(location.href);
        const tags = readTags(current);
        const drawer = document.querySelector('zinko-store-categories');
        const scope = current.searchParams.get('zinko_scope') || drawer?.dataset.scope || 'all';
        this.querySelectorAll('[data-type-link],[data-type-all]').forEach(link => {
          const url = new URL(current);
          url.searchParams.delete('filter.p.product_type');
          if (link.hasAttribute('data-type-link')) {
            JSON.parse(link.dataset.typeValues || JSON.stringify([link.dataset.typeLink])).forEach(type => url.searchParams.append('filter.p.product_type', type));
          }
          url.searchParams.delete('page');
          const selectedTypes = current.searchParams.getAll('filter.p.product_type').flatMap(value => value.split(','));
          const groupTypes = JSON.parse(this.dataset.groupTypes || '[]');
          if (link.hasAttribute('data-type-all')) groupTypes.forEach(type => url.searchParams.append('filter.p.product_type', type));
          const outerwearAll = link.hasAttribute('data-type-all') && this.dataset.categoryGroup === 'outerwear';
          const active = outerwearAll ? tags.includes('ytterklader-sortiment') : !tags.some(tag => groups.socks.includes(tag)) && (link.hasAttribute('data-type-all') ? selectedTypes.length === 0 || groupTypes.length > 0 && groupTypes.every(type => selectedTypes.includes(type)) : selectedTypes.length > 0 && selectedTypes.every(type => JSON.parse(link.dataset.typeValues || JSON.stringify([link.dataset.typeLink])).includes(type)));
          link.classList.toggle('is-selected', active);
          if (active) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
          if (!current.pathname.includes('/search')) url.pathname = this.dataset.categoryBase || url.pathname;
          const destination = outerwearAll ? outerwearUrl({ base: url, scope, value: 'ytterklader-sortiment', tags }) : tagUrl({ tags: tags.filter(tag => !Object.entries(groups).some(([key, values]) => key !== 'characters' && values.includes(tag))), base: url, scope });
          destination.hash = 'ZinkoFilterContext';
          link.href = destination.toString();
        });
        this.querySelectorAll('[data-outerwear-link]').forEach(link => {
          const base = new URL(current);
          if (!current.pathname.includes('/search')) base.pathname = this.dataset.categoryBase || base.pathname;
          const destination = outerwearUrl({ base, scope, value: link.dataset.outerwearLink, tags });
          destination.hash = 'ZinkoFilterContext';
          link.href = destination.toString();
          const active = tags.includes(link.dataset.outerwearLink);
          link.classList.toggle('is-selected', active);
          if (active) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        this.querySelectorAll('[data-feature-link]').forEach(link => {
          const group = link.dataset.featureLink;
          const selected = tags.find(tag => groups[group].includes(tag)) || '';
          const next = tags.filter(tag => !groups[group].includes(tag));
          if (link.dataset.parentFeature && !next.includes(link.dataset.parentFeature)) next.push(link.dataset.parentFeature);
          if (link.dataset.featureValue) next.push(link.dataset.featureValue);
          const base = new URL(current);
          if (['sweats', 'sleepwear', 'underwear', 'socks', 'swimwear', 'jackets', 'overalls', 'rainwear'].includes(group)) {
            const types = JSON.parse(this.dataset.groupTypes || '[]').filter(type => group === 'socks' ? /strump/i.test(type) && !/strumpbyx/i.test(type) : group === 'sweats' ? /hood|sweatshirt/i.test(type) : group === 'underwear' ? /underkläder/i.test(type) : group === 'overalls' ? /overall/i.test(type) : group === 'rainwear' ? /regnställ|regnkläder|regnjack|regnbyx/i.test(type) : group === 'jackets' ? /jack/i.test(type) : group === 'swimwear' ? /bad|uv/i.test(type) : /pyjamas|nattkläder|nattlinne|morgonrock/i.test(type));
            if (types.length) {
              base.searchParams.delete('filter.p.product_type');
              types.forEach(type => base.searchParams.append('filter.p.product_type', type));
              if (!current.pathname.includes('/search')) base.pathname = this.dataset.categoryBase || base.pathname;
            }
          }
          const destination = tagUrl({ tags: next, base, scope });
          destination.hash = 'ZinkoFilterContext';
          link.href = destination.toString();
          const active = selected === link.dataset.featureValue;
          link.classList.toggle('is-selected', active);
          if (active) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        this.hidden = !this.querySelector('nav');
        this.updateAvailability();
        requestAnimationFrame(() => { this.groupActiveCategories(); this.updateArrows(); });
      }
    });
  }
  if (!customElements.get('zinko-store-categories')) {
    customElements.define('zinko-store-categories', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.form = this.closest('form');
        this.form.addEventListener('input', event => {
          if (event.target.matches('[data-product-type],[data-group-all],[data-outerwear-choice],[data-feature-group],[data-age-value],[data-character-value],[data-all-characters]')) event.stopImmediatePropagation();
        }, true);
        this.syncFromURL();
        this.addEventListener('click', event => {
          const reset = event.target.closest('[data-category-reset]');
          if (reset) {
            event.preventDefault();
            this.querySelectorAll('[data-product-type]').forEach(input => { input.checked = false; });
            this.querySelectorAll('[data-character-value],[data-all-characters]').forEach(input => { input.checked = false; });
            this.outerwearSelection = '';
            this.querySelectorAll('[data-outerwear-choice]').forEach(input => { input.checked = false; });
            this.categoryChanged = true;
            this.updateLink();
          }
          const toggle = event.target.closest('[data-category-toggle]');
          if (!toggle) return;
          event.preventDefault();
          event.stopPropagation();
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!expanded));
          if (toggle.parentElement === this) {
            this.querySelector('nav').hidden = expanded;
            this.querySelector('.zinko-category-hint').hidden = expanded;
          } else toggle.nextElementSibling.hidden = expanded;
        });
        this.form.addEventListener('change', event => {
          const outerwearAll = event.target.matches('[data-group-all]') && event.target.closest('[data-category-group]')?.dataset.categoryGroup === 'outerwear';
          const categoryInput = event.target.matches('[data-product-type],[data-group-all],[data-outerwear-choice]');
          if (categoryInput) {
            this.form.querySelectorAll('[data-feature-group]').forEach(input => { input.checked = input.value === ''; });
            this.categoryChanged = true;
          }
          if (outerwearAll) {
            this.outerwearSelection = event.target.checked ? 'ytterklader-sortiment' : '';
            this.querySelectorAll('[data-product-type],[data-outerwear-choice]').forEach(input => { input.checked = false; });
            this.updateLink();
            return;
          }
          if (event.target.matches('[data-product-type],[data-outerwear-choice]')) this.outerwearSelection = '';
          if (event.target.matches('[data-group-all]')) {
            event.target.closest('[data-category-group]').querySelectorAll('[data-product-type]:not(:disabled)').forEach(input => { input.checked = event.target.checked; });
            if (event.target.checked) {
              const types = [...event.target.closest('[data-category-group]').querySelectorAll('[data-product-type]:not(:disabled)')].map(input => input.value);
              const modes = modesFor(types);
              this.form.querySelectorAll('[data-feature-group]').forEach(input => {
                if (modes.has(input.dataset.featureGroup)) input.checked = input.value === '';
              });
            }
          }
          if (event.target.matches('[data-product-type],[data-group-all],[data-character-value],[data-all-characters]')) this.categoryChanged = true;
          if (event.target.matches('[data-all-characters]') && event.target.checked) this.querySelectorAll('[data-character-value]').forEach(input => { input.checked = false; });
          if (event.target.matches('[data-character-value]') && event.target.checked) this.querySelector('[data-all-characters]').checked = false;
          this.updateLink();
        });
        this.form.addEventListener('input', event => {
          if (!event.target.matches('[data-group-all]')) this.updateLink();
        });
        this.form.addEventListener('click', event => {
          const apply = event.target.closest('[data-category-apply]');
          if (apply) this.updateLink();
        });
      }
      syncFromURL() {
        this.categoryChanged = false;
        const url = new URL(location.href);
        const requestedScope = url.searchParams.get('zinko_scope');
        if (requestedScope && (requestedScope === 'all' || ageTags[requestedScope])) {
          this.dataset.scope = requestedScope;
          const age = this.form.querySelector(`[data-age-value="${requestedScope}"]`);
          if (age) age.checked = true;
          if (age?.dataset.ageUrl) this.dataset.baseUrl = age.dataset.ageUrl;
        }
        if (url.pathname.includes('/search') && url.searchParams.has('zinko_q')) {
          document.querySelectorAll('input[name="q"]').forEach(input => { input.value = searchText(url); });
        }
        const selected = url.searchParams.has('zinko_types') ? JSON.parse(url.searchParams.get('zinko_types')) : url.searchParams.getAll('filter.p.product_type').flatMap(value => value.split(','));
        this.querySelectorAll('[data-product-type]').forEach(input => { input.checked = selected.includes(input.value); });
        const tags = readTags(url);
        this.outerwearSelection = tags.includes('ytterklader-sortiment') ? 'ytterklader-sortiment' : '';
        const choices = url.searchParams.has('zinko_outer') ? url.searchParams.get('zinko_outer').split(',') : tags.filter(tag => groups.outerwear.includes(tag));
        this.querySelectorAll('[data-outerwear-choice]').forEach(input => { input.checked = choices.includes(input.value); });
        this.form.querySelectorAll('[data-feature-group]').forEach(input => { input.checked = input.value === (tags.find(tag => groups[input.dataset.featureGroup].includes(tag)) || ''); });
        this.querySelectorAll('[data-character-value]').forEach(input => { input.checked = tags.includes(input.value); });
        this.querySelector('[data-all-characters]').checked = tags.includes('licence');
        this.updateLink();
      }
      updateLink() {
        const current = new URL(location.href);
        const age = this.form.querySelector('[data-age-value]:checked');
        const scope = age?.value || this.dataset.scope;
        const ageChanged = scope !== this.dataset.scope;
        this.form.querySelectorAll('[data-mini-only]').forEach(label => {
          label.hidden = scope !== 'barnklader-1-5-ar';
          const input = label.querySelector('input');
          input.disabled = label.hidden;
          if (label.hidden) input.checked = false;
        });
        const availableTypes = JSON.parse(age?.dataset.ageTypes || '[]');
        this.querySelectorAll('[data-product-type]').forEach(input => {
          const available = scope === 'all' || availableTypes.includes(input.value);
          input.disabled = !available;
          input.closest('label').hidden = !available;
          if (!available) input.checked = false;
        });
        this.querySelectorAll('[data-category-group]').forEach(group => {
          if (group.dataset.categoryGroup !== 'characters') group.hidden = !group.querySelector('[data-product-type]:not(:disabled)');
        });
        const selectedTypes = [...this.querySelectorAll('[data-product-type]:checked')].map(input => input.value);
        const selectedOuter = [...this.querySelectorAll('[data-outerwear-choice]:checked')].map(input => input.value);
        this.querySelectorAll('[data-category-group]').forEach(group => {
          const inputs = [...group.querySelectorAll('[data-product-type]:not(:disabled)')];
          const all = group.querySelector('[data-group-all]');
          if (!all) return;
          const count = inputs.filter(input => input.checked).length;
          const outerwear = group.dataset.categoryGroup === 'outerwear';
          all.checked = outerwear ? this.outerwearSelection === 'ytterklader-sortiment' : inputs.length > 0 && count === inputs.length;
          all.indeterminate = !all.checked && (outerwear ? count > 0 || selectedOuter.length > 0 : count > 0 && count < inputs.length);
        });
        const params = new URLSearchParams();
        for (const [key, value] of new FormData(this.form)) {
          if (value && (key.startsWith('filter.') || ['sort_by', 'q', 'options[prefix]', 'type'].includes(key))) params.append(key, value);
        }
        current.searchParams.forEach((value, key) => { if (!params.has(key) && !key.startsWith('filter.') && ['preview_theme_id', 'zinko_q', 'zinko_scope'].includes(key)) params.set(key, value); });
        let tags = readTags(current).filter(tag => !known.includes(tag));
        if (ageChanged) tags = tags.filter(tag => !Object.values(ageTags).includes(tag));
        const drawerContext = this.form.querySelector('zinko-filter-drawer-context');
        const urlTypes = current.searchParams.has('zinko_types') ? JSON.parse(current.searchParams.get('zinko_types')) : current.searchParams.getAll('filter.p.product_type').flatMap(value => value.split(','));
        const explicitTypes = this.categoryChanged ? selectedTypes : urlTypes;
        const contextModes = this.outerwearSelection || selectedOuter.length ? new Set() : explicitTypes.length ? modesFor(explicitTypes) : new Set((drawerContext?.dataset.modes || '').trim().split('|'));
        if (this.categoryChanged && !selectedTypes.length) contextModes.clear();
        drawerContext?.querySelectorAll('[data-context-group]').forEach(details => { details.hidden = !contextModes.has(details.dataset.contextGroup); });
        const allowed = this.categoryChanged ? contextModes : null;
        let featureExpands = false;
        this.form.querySelectorAll('[data-feature-group]:checked').forEach(input => {
          if (!input.value || allowed && !allowed.has(input.dataset.featureGroup)) return;
          tags.push(input.value);
          const categoryGroup = { sweats: 'tops', sleepwear: 'sleepwear', underwear: 'underwear', swimwear: 'swimwear', jackets: 'outerwear', overalls: 'outerwear', rainwear: 'outerwear' }[input.dataset.featureGroup];
          if (!categoryGroup) return;
          const candidates = [...this.querySelectorAll(`[data-category-group="${categoryGroup}"] [data-product-type]`)].map(element => element.value);
          const types = input.dataset.featureGroup === 'overalls' ? candidates.filter(type => /overall/i.test(type)) : input.dataset.featureGroup === 'rainwear' ? candidates.filter(type => /regnställ|regnkläder|regnjack|regnbyx/i.test(type)) : input.dataset.featureGroup === 'jackets' ? candidates.filter(type => /jack/i.test(type)) : input.dataset.featureGroup === 'sweats' ? candidates.filter(type => /hood|sweatshirt/i.test(type)) : input.dataset.featureGroup === 'underwear' ? candidates.filter(type => /underkläder/i.test(type)) : candidates;
          if (types.length) {
            featureExpands = true;
            params.delete('filter.p.product_type');
            types.forEach(type => params.append('filter.p.product_type', type));
          }
        });
        if (this.querySelector('[data-all-characters]:checked')) tags.push('licence');
        this.querySelectorAll('[data-character-value]:checked').forEach(input => tags.push(input.value));
        let base = current;
        if (ageChanged || (this.categoryChanged || featureExpands) && !current.pathname.includes('/search')) base = age?.dataset.ageUrl || this.dataset.baseUrl;
        const plainText = current.pathname.includes('/search') ? searchText(current) : '';
        const url = this.outerwearSelection ? outerwearUrl({ base: age?.dataset.ageUrl || this.dataset.baseUrl, params, scope, value: this.outerwearSelection, tags }) : selectedOuter.length ? categoryUnionUrl({ base: age?.dataset.ageUrl || this.dataset.baseUrl, params, scope, types: selectedTypes, choices: selectedOuter, tags, text: plainText }) : tagUrl({ tags, base, params, scope, text: plainText, forceSearch: current.pathname.includes('/search') });
        url.hash = 'ZinkoFilterContext';
        this.form.querySelectorAll('[data-category-apply]').forEach(link => { link.href = url.toString(); });
        const crossRevision = this.crossRevision = (this.crossRevision || 0) + 1;
        const crossBase = outerwearUrl({ base: age?.dataset.ageUrl || this.dataset.baseUrl, params, scope, value: 'ytterklader-sortiment', tags });
        availableChoices(crossBase).then(({ tags: availableTags }) => {
          if (crossRevision !== this.crossRevision || !this.isConnected) return;
          this.querySelectorAll('[data-outerwear-choice]').forEach(input => {
            const available = availableTags.has(input.value) || input.checked;
            input.disabled = !available;
            input.closest('label').hidden = !available;
          });
          const outerGroup = this.querySelector('[data-category-group="outerwear"]');
          if (outerGroup) outerGroup.hidden = !outerGroup.querySelector('[data-product-type]:not(:disabled),[data-outerwear-choice]:not(:disabled)');
        }).catch(() => {});
        const contextRevision = this.contextRevision = (this.contextRevision || 0) + 1;
        ['jackets', 'overalls', 'rainwear', 'shoes', 'accessories'].filter(group => contextModes.has(group)).forEach(group => {
          const jacketBase = tagUrl({ tags: tags.filter(tag => !groups[group].includes(tag)), base: url, scope });
          availableChoices(jacketBase).then(({ tags: availableTags }) => {
            if (contextRevision !== this.contextRevision || !this.isConnected) return;
            this.form.querySelectorAll(`[data-feature-group="${group}"]`).forEach(input => {
              const available = !input.value || availableTags.has(input.value) || input.checked;
              input.disabled = !available;
              input.closest('label').hidden = !available;
            });
          }).catch(() => {});
        });
      }
    });
  }
})();

